module.exports = __webpack_public_path__ + "media/images/iconDelete__okGreen--dark-e0fdf24078ebeb86fcf8fbb9ec3569e3.png";